import NumericFunction from "../../../utils/NumericFunction";
 import numeric from "../../../utils/NumericFunction";

const PrintType7Header3 = ({data, title ,description}) => {

  let shopName = ''
  let date = ''
  // here i MUST give Data From
  console.log(data.headerAndFooter.header)
  data.headerAndFooter.header.forEach((v, index) => {
    date = v.id === 'Memo69' ? v.value : date;
    shopName = v.id === 'Memo10' ? v.value : shopName;
  })


  return (
    <div className={""}>

      <div className={" w-100 headerPrintType7 text-center"}>
        <div className={'d-flex  justify-content-between align-items-center'}>
          <div></div>
          <div >
            <div>{title}</div>

            <div style={{fontWeight: 'bold'}}> {shopName}</div>
          </div>
          <div>
            <div>{'تاریخ'}: {numeric.e2p(date)}</div>
          </div>



        </div>
        <div className={'py-2'}> <span>شرح سند:</span> {description && <>{description}</>}</div>

      </div>
    </div>
  );
};

export default PrintType7Header3;
